import React, { useState } from 'react';
type Notification = {
  id: string;
  event: string;
  date: string;
  impact: 'high_negative' | 'medium_negative' | 'low_positive' | 'medium_positive' | 'high_positive';
  acknowledgedBy: string | null;
};
const notifications: Notification[] = [{
  id: '1',
  event: 'Financial statement: Revenue declined 35% YoY, negative cash flow',
  date: '2/15/2026',
  impact: 'high_negative',
  acknowledgedBy: null
}, {
  id: '2',
  event: 'C-Suite Change: CFO and VP Sales departed the company',
  date: '11/22/2025',
  impact: 'high_negative',
  acknowledgedBy: null
}, {
  id: '3',
  event: 'DBT increased from 15 to 45 days - payment behavior deteriorating',
  date: '10/15/2025',
  impact: 'high_negative',
  acknowledgedBy: null
}, {
  id: '4',
  event: 'News: Key product launch delayed by 6 months due to development issues',
  date: '8/10/2025',
  impact: 'medium_negative',
  acknowledgedBy: null
}];
function ImpactIndicator({
  impact
}: {
  impact: Notification['impact'];
}) {
  if (impact === 'high_negative') {
    return <div className="flex items-end gap-0.5 justify-center" data-id="element-2398" data-mp="3picybhz3ufg7">
        <div className="w-1.5 h-2 bg-red-500 rounded-sm" data-id="element-2399" data-mp="3kpth8b17l26n" />
        <div className="w-1.5 h-3.5 bg-red-500 rounded-sm" data-id="element-2400" data-mp="3ko8nuoqmrpad" />
        <div className="w-1.5 h-5 bg-red-500 rounded-sm" data-id="element-2401" data-mp="3fq76c88ury10" />
      </div>;
  }
  if (impact === 'medium_negative') {
    return <div className="flex items-end gap-0.5 justify-center" data-id="element-2402" data-mp="3bqycl3dtc05g">
        <div className="w-1.5 h-2 bg-red-500 rounded-sm" data-id="element-2403" data-mp="36pipz6vzllky" />
        <div className="w-1.5 h-3.5 bg-red-500 rounded-sm" data-id="element-2404" data-mp="31rh7oo6dxqaj" />
        <div className="w-1.5 h-5 bg-gray-200 rounded-sm" data-id="element-2405" data-mp="31rzc4837batj" />
      </div>;
  }
  if (impact === 'low_positive') {
    return <div className="flex items-end gap-0.5 justify-center" data-id="element-2406" data-mp="2wuqs01yhswpn">
        <div className="w-1.5 h-2 bg-green-500 rounded-sm" data-id="element-2407" data-mp="zyt3abi08wt6" />
        <div className="w-1.5 h-3.5 bg-gray-200 rounded-sm" data-id="element-2408" data-mp="v19eihnol1mz" />
        <div className="w-1.5 h-5 bg-gray-200 rounded-sm" data-id="element-2409" data-mp="uywwk4hxar9x" />
      </div>;
  }
  if (impact === 'medium_positive') {
    return <div className="flex items-end gap-0.5 justify-center" data-id="element-2410" data-mp="2u7ogde88b37g">
        <div className="w-1.5 h-2 bg-green-500 rounded-sm" data-id="element-2411" data-mp="2u99cv9e3sw7y" />
        <div className="w-1.5 h-3.5 bg-green-500 rounded-sm" data-id="element-2412" data-mp="2fk3cvj7fz1z0" />
        <div className="w-1.5 h-5 bg-gray-200 rounded-sm" data-id="element-2413" data-mp="2ki4wq6coz5bj" />
      </div>;
  }
  // high_positive
  return <div className="flex items-end gap-0.5 justify-center" data-id="element-2414" data-mp="387z8ekl9ynu7">
      <div className="w-1.5 h-2 bg-green-500 rounded-sm" data-id="element-2415" data-mp="388inltjjiy4j" />
      <div className="w-1.5 h-3.5 bg-green-500 rounded-sm" data-id="element-2416" data-mp="3d72e8792wy38" />
      <div className="w-1.5 h-5 bg-green-500 rounded-sm" data-id="element-2417" data-mp="3d4g3jyqw62gs" />
    </div>;
}
export function InitechNotificationsTab() {
  const [selected, setSelected] = useState<Set<string>>(new Set());
  const toggleAll = () => {
    if (selected.size === notifications.length) {
      setSelected(new Set());
    } else {
      setSelected(new Set(notifications.map(n => n.id)));
    }
  };
  const toggleOne = (id: string) => {
    const next = new Set(selected);
    if (next.has(id)) {
      next.delete(id);
    } else {
      next.add(id);
    }
    setSelected(next);
  };
  return <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-2418" data-mp="1fac0eoy7p1wj">
      <div className="p-5 border-b border-gray-200" data-id="element-2419" data-mp="1u7mb3w3163r7">
        <h3 className="text-lg font-bold text-gray-900" data-id="element-2420" data-mp="1p9b2fooh1zak">Notifications</h3>
      </div>
      <div className="overflow-x-auto" data-id="element-2421" data-mp="11jgp7608q8ps">
        <table className="w-full text-sm text-left" data-id="element-2422" data-mp="11kieaee3cvqi">
          <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-2423" data-mp="11h4dhal2sul6">
            <tr data-id="element-2424" data-mp="wi9hf6y3l9j4">
              <th className="px-5 py-3 w-10" data-id="element-2425" data-mp="wijbp6q6e2um">
                <input type="checkbox" checked={selected.size === notifications.length} onChange={toggleAll} className="w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer" data-id="element-2426" data-mp="1babmd5f0ysq0" />
              </th>
              <th className="px-5 py-3 font-medium" data-id="element-2427" data-mp="dtcy1y48o1fo">Event</th>
              <th className="px-5 py-3 font-medium text-center w-32" data-id="element-2428" data-mp="3d8f37xybdu69">Date</th>
              <th className="px-5 py-3 font-medium text-center w-24" data-id="element-2429" data-mp="3h9gv1tpwj3y7">Impact</th>
              <th className="px-5 py-3 font-medium text-center w-40" data-id="element-2430" data-mp="3h7e6zf8b7kw4">
                Acknowledged By
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-2431" data-mp="3r0bszvcifrzh">
            {notifications.map(n => <tr key={n.id} className="hover:bg-gray-50 transition-colors" data-id="element-2432" data-mp="3vz6c6yee3ik4">
                <td className="px-5 py-4" data-id="element-2433" data-mp="4rttug1rsz2m">
                  <input type="checkbox" checked={selected.has(n.id)} onChange={() => toggleOne(n.id)} className="w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer" data-id="element-2434" data-mp="4qim6557f768" />
                </td>
                <td className="px-5 py-4 text-gray-900" data-id="element-2435" data-mp="2an4vj95lc5ok">{n.event}</td>
                <td className="px-5 py-4 text-gray-500 text-center whitespace-nowrap" data-id="element-2436" data-mp="2fkwmo0yevnrp">
                  {n.date}
                </td>
                <td className="px-5 py-4 text-center" data-id="element-2437" data-mp="282f83gbohirv">
                  <ImpactIndicator impact={n.impact} data-id="element-2438" data-mp="238ufk3suth02" />
                </td>
                <td className="px-5 py-4 text-gray-500 text-center" data-id="element-2439" data-mp="1ya9iuect9fgd">
                  {n.acknowledgedBy ?? '--'}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      <div className="flex items-center justify-end gap-4 px-5 py-3 border-t border-gray-200 text-sm text-gray-500" data-id="element-2440" data-mp="2qzq85354wg8d">
        <span data-id="element-2441" data-mp="2m1omcagbq2t7">Rows per page: 5</span>
        <span data-id="element-2442" data-mp="2lykcoxk3aev5">1–4 of 4</span>
        <div className="flex gap-1" data-id="element-2443" data-mp="2h0r6i4isdkuv">
          <button className="p-1 rounded hover:bg-gray-100 text-gray-400 cursor-not-allowed" data-id="element-2444" data-mp="2gzpikzgo93vq">
            ‹
          </button>
          <button className="p-1 rounded hover:bg-gray-100 text-gray-400 cursor-not-allowed" data-id="element-2445" data-mp="2d1rww6m40zx3">
            ›
          </button>
        </div>
      </div>
    </div>;
}